/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 法语 国际化语言文件
 */
// 法语.js
export default {
  centerAgent: {
    subagency: 'Sous-agence',
    search: 'Rechercher',
    subagencyIncome: 'Revenus de Sous-agence',
    last29Days: '29 Derniers Jours',
    excludingToday: 'Excluant Aujourd\'hui',
    commission: 'Commission',
    last30Days: 'Données des 30 Derniers Jours',
    rank: 'Classement',
    hostNumber: 'Nombre d\'Hôtes',
    recent30Days: 'Revenus de l\'Hôte sur 30 Jours Récents',
    commissionRate: 'Taux de Commission',
    myCommission: 'Ma Commission',
    remove: 'Retirer',
    thisAction: 'Cette action supprimera {hostoragent} {hostname}  de votre équipe. Confirmez-vous poursuivre ?',
    dashboard: 'Tableau de Bord',
    information: 'Informations',
    dataCenter: 'Centre de Données',
    hostList: 'Liste des Hôtes',
    bdList: 'Liste des BD',
    agencyList: 'Liste des Agences',
    myRight: 'Mes Droits',
    numberOf: 'Nombre d\'Agences',
    inviteAgency: 'Inviter une Agence',
    numberOfHost: 'Nombre d\'Hôtes',
    inviteHost: 'Inviter un hôte',
    inviteHostlinkcopied: 'Lien d\'invitation copié',
    tipsShare: 'Conseil : Partagez le lien d\'invitation avec vos amis',
    thisMonthD: 'Données de Ce Mois',
    formDay1: 'De day1 à day2',
    hostGift: 'Points Cadeau de l\'Hôte',
    agentCommission: 'Commission d\'agent',
    currentLevel: 'Niveau Actuel',
    commissionRateOf: 'Taux de commission sur le revenu des agents',
    baseSalary: 'Salaire de Base',
    stillNeed: 'J\'ai encore besoin',
    toReach: 'pour atteindre',
    reachedthe: 'Tâche publicitaire',
    advertisementTask: 'Aperçu des données',
    dataOverview: 'Aperçu des données',
    today: 'Aujourd\'hui',
    hostPoint: 'Points d\'hôte',
    agentsPoints: 'Revenu des Points d\'Agent',
    thisMonth: 'Ce mois-ci',
    month: 'Mois',
    lastMonth: 'Mois dernier',
    bdNumber: 'Nombre de BD',
    hostIncome: 'Revenu de l\'Hôte',
    todayIncome: 'Revenu du Jour',
    past30Days: '30 Derniers Jours',
    host: 'Hôte',
    country: 'Pays',
    level7: 'Niveau / Revenu 7 Jours',
    pointIncome: 'Revenu des Points',
    liveDuration: 'Durée en direct',
    joinTime: 'Heure d\'Inscription',
    state: 'Statut',
    operation: 'Opération',
    bd: 'BD',
    totalHosts: 'Revenu Total des Hôtes',
    totalAgents: 'Revenu Total des Agents',
    agent: 'Agent',
    agentLevel: 'Niveau d\'Agent / Taux de Commission',
    commissionIncome: 'Revenu des Commissions',
    showDirect: 'Afficher uniquement les agents directs. Les données d\'aujourd\'hui sont exclues',
    excludingTodayData: 'Exclut les données d\'aujourd\'hui',
    packages: 'Forfaits',
    contents: 'Contenus',
    balance: 'Solde',
    release: 'Publier',
    issue: 'Émettre',
    createBd: 'Créer BD',
    times: 'fois',
    authorizeCs: 'Autoriser CS',
    giftTo: 'Offrir à l\'Utilisateur',
    bdCreation: 'Limite de Création de BD Restante',
    csAuthorization: 'Quota d\'Autorisation CS Restant',
    giftName: 'Nom du Cadeau',
    giftContents: 'Contenu du Cadeau',
    check: 'Vérifier',
    cancel: 'Annuler',
    tip: 'Pourboire',
    recipientsVip: 'Le niveau VIP du destinataire dépasse la limite du pack cadeau. Les avantages VIP de ce cadeau seront désactivés. Confirmez-vous la continuation ?',
    confirm: 'Confirmer',
    authorize: 'Autoriser',
    inviteBy: 'Inviter par ID Utilisateur',
    invite: 'Inviter',
    inviteLink: 'Lien d\'Invitation',
    copy: 'Copier',
    success: 'Succès',
    pleaseCheck: 'Veuillez vérifier l\'ID utilisateur',
    totalGift: 'Revenu total des cadeaux de tous les hôtes (excluant les récompenses de plateforme comme les classements, tâches, etc.), incluant les revenus des cadeaux des sous-agences.',
    totalAgentsCom: 'Commission totale des agents sur les revenus de leurs hôtes, incluant les commissions des sous-agents.',
    allAgent: 'Tous les Agents',
    directAgent: 'Agent Direct',
    indirectAgent: 'Agent Indirect',
    newUpgraded: 'Nouvel Agent Amélioré',
    newS: 'Nouveaux Agents S',
    newB: 'Nouveaux Agents B',
    newC: 'Nouveaux Agents C',
    expectedReward: 'Récompense Attendue',
    newA: 'Nouveaux Agents A',
    agencyLevel: 'Niveau d\'Agence',
    nickname: 'Surnom',
    upgradeDate: 'Date de Mise à Niveau',
    bdPolicy: 'Politique BD',
    agencyDetail: 'Détails de l\'Agence',
    agency: 'Agence',
    hostCommission: 'Commission d\'Hôte',
    last6Days: '6 Derniers Jours',
    giftIncome: 'Revenu de Cadeau',
    mins: 'minutes',
    agencyCenter: 'Centre d\'Agence',
    myIncome: 'Mon Revenu Aujourd\'hui',
    totalHost: 'Points d\'Hôte Totaux',
    overview: 'Aperçu',
    hostPoints: 'Points d\'Hôte',
    myHosts: 'Mes Points d\'Hôte',
    subagentHost: 'Points d\'Hôte des Sous-agents',
    subagencyNumber: 'Nombre de Sous-agences',
    otherIncome: 'Autres Revenus',
    contactAdmin: 'Contacter l\'Admin',
    whatsapp: 'WhatsApp',
    bdCenter: 'Centre BD',
    copySuccess: 'Copie Réussie',
    pleaseInput: 'Veuillez saisir le montant de la recharge, minimum 10',
    agencyPolicy: 'Politique d\'Agence',
    agencyCommission: 'Commission d\'Agence',
    agencyCommission2: 'Commission d\'Agence = Taux de Commission × Revenu Total des Cadeaux de Tous les Hôtes (excluant les récompenses de plateforme comme les classements, tâches, etc.)',
    excludingPlatform: '(excluant les récompenses de plateforme comme les classements, tâches, etc.)',
    agencyCommissionCalculation: 'Calcul de la Commission d\'Agence',
    level: 'Niveau',
    pointsTarget: 'Objectif de Points (30 Derniers Jours)',
    points10000: '10,000 Points = 1 USD (M= million)',
    note1: 'Note 1 : Revenu Valide Total = Votre revenu d\'agence + Revenu de chaque niveau de vos sous-agences',
    note2: 'Note 2 : Les commissions d\'agence seront créditées en temps réel lorsque l\'hôte reçoit un cadeau.',
    note3: 'Note 3 : Le montant de retrait minimum est de 10 USD, et les retraits doivent être effectués par multiples de 10 (par exemple : 10 USD, 20 USD, 30 USD).',
    subagencycommission: 'Commission de Sous-Agence',
    theMain: 'L\'agence principale peut gagner des commissions sur les revenus de chaque niveau de sous-agences (T1, T2, T3, T4, ... Tn), avec un taux de commission maximum de 16%.',
    forExample: 'Par exemple :',
    agencyA: 'L\'Agence A invite l\'Agence B et l\'Agence C.',
    agencyB: 'L\'Agence B invite l\'Agence D et l\'Agence E.',
    agencyC: 'L\'Agence C invite l\'Agence F.',
    noteFigures: '(Note : les chiffres entre parenthèses représentent le revenu des hôtes sous chaque agence).',
    thusWe: 'Ainsi, nous pouvons calculer le Revenu Valide Total et le Taux de Commission des agences de l\'Agence A à l\'Agence F.',
    totalValid: 'Revenu Valide Total = Revenu de Votre Agence + Revenu de Chaque Niveau de Sous-Agence',
    aTotal: 'A Revenu Valide Total = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (taux de commission de 20%)',
    bTotal: 'B Revenu Valide Total = B + D + E = 20M + 20M + 30M = 70M (taux de commission de 16%)',
    cTotal: 'C Revenu Valide Total = C + F = 70M + 80M =150M (taux de commission de 20%)',
    dTotal: 'D Revenu Valide Total =20M (taux de commission de 12%)',
    eTotal: 'E Revenu Valide Total =30M (taux de commission de 12%)',
    fTotal: 'F Revenu Valide Total =80M (taux de commission de 16%)',
    subagencyCommission: 'Commission de Sous-agence = (Taux de commission de l\'agence principale - Taux de commission de la sous-agence) × Revenu Valide Total de la sous-agence',
    agencyAC: 'Commission de l\'Agence {A} de l\'Agence {B}',
    thereforeAgency: 'Par conséquent, commission totale de l\'Agence {A} des sous-agences',
    sinceAgency: 'Comme les Agences D, E et F n\'ont pas de sous-agences, elles ne peuvent pas gagner de commissions de sous-agence.',
    seniorPolicy: 'Politique Senior',
    nomore: 'Plus de Données',
    active: 'Actif',
    disabled: 'Désactivé',
    deleted: 'Supprimé',
    lastLogintime: 'Dernière Connexion',
    onmic: 'Au Micro Aujourd\'hui'
  },
  sellerCoin: {
    detailsOf: 'Détails de Retrait',
    fundsSent: 'Fonds Envoyés',
    transfer: 'Transfert',
    totalIncome: 'Revenu Total',
    orderIncome: 'Revenu de Commande',
    estimatedReward: 'Récompense Estimée',
    amount: 'Montant',
    applicantId: 'ID du Demandeur',
    applicantName: 'Nom du Demandeur',
    orderId: 'Numéro de commande',
    uploadScreenshot: 'Uploader une Capture d\'Écran',
    ensureWithdrawal: 'Assurez-vous que le retrait est réussi, puis téléchargez une capture d\'écran et cliquez sur le bouton ci-dessous pour informer le demandeur.',
    remain: 'Restant',
    pleasePay: 'Veuillez payer immédiatement et télécharger le reçu. Si vous dépassez le délai, l\'éligibilité au paiement de la commande sera annulée.',
    youCan: 'Vous pouvez gagner jusqu\'à 5 000 points d\'invitation par jour.',
    pleaseComplete: 'Veuillez compléter le retrait à temps ',
    unableTo: 'Impossible de Payer, Refuser',
    notifyThe: 'Notifier le Demandeur',
    youCanGet: 'Vous pouvez obtenir 1% à 3% de bonus supplémentaire si vous traitez les commandes en temps opportun.',
    ifYou: 'Si vous traitez les commandes dans les 30 minutes, vous pouvez obtenir 3% de bonus.',
    egThe: 'Par exemple : Une commande d\'une valeur de 90 000 points, que vous traitez en 30 minutes, vous donne droit à 3% de bonus, soit 90 000 × 3% = 2 700 points.',
    gotIt: 'Compris',
    pleaseUpload: 'Veuillez télécharger l\'image',
    detail: 'Détail',
    balance: 'Balance',
    exchange: 'Échanger',
    all: 'Tout',
    recharge: 'Recharger',
    official: 'Officiel',
    exchangeDetail: 'Détail de l\'échange',
    coinSeller: 'Vendeur de Pièces',
    levelUp: 'Monter de Niveau',
    currentLevel: 'Current level',
    myBalance: 'Mon Solde',
    details: 'Détails',
    paymentMethod: 'Méthode de paiement',
    myOrder: 'Ma Commande',
    paymentMenthod: 'Méthode de Paiement',
    acceptingOrders: 'Acceptation des Commandes',
    unavailable: 'Indisponible',
    greetingMessage: 'Paramètres du Message de Bienvenue',
    serviceUnavailable: 'Service Indisponible',
    thisFeature: 'Cette fonctionnalité est temporairement verrouillée. Veuillez contacter le service client pour obtenir de l\'aide.',
    editMessage: 'Modifier le Message',
    customizeYour: 'Personnalisez votre message d\'accueil. Vous pouvez inclure des informations utiles sur la recharge de pièces.',
    theMessage: 'Le message sera automatiquement envoyé lorsqu\'un nouvel utilisateur commence une conversation privée avec vous',
    save: 'Sauvegarder',
    pleaseEnterMessge: 'Veuillez saisir votre message d\'accueil',
    salesMethod: 'Méthode de Vente',
    user: 'Utilisateur',
    coinseller: 'Vendeur de Pièces',
    userId: 'Identifiant d\'utilisateur',
    check: 'Check',
    coinAmount: 'Montant de Pièces',
    pleaseEnter: 'Veuillez entrer un multiple de 1',
    enterAt: 'Entrez au moins 100, en multiples de 1',
    transferDetails: 'Détails du Transfert',
    recommendSeller: 'Recommander le Vendeur',
    recent30Day: 'Ventes de Pièces des 30 Derniers Jours',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry: 'Votre pays n\'a actuellement aucun vendeur de pièces disponible.',
    pleaseContact: 'Veuillez contacter le service client.',
    customerSupport: 'service client',
    contact: 'Contacter',
    customRecharge: 'Recharge Personnalisée',
    rechargeDetails: 'Détails de la Recharge',
    myPoints: 'Mes Points',
    todayRemaining: 'Quota restant aujourd\'hui',
    customExchange: 'Échange Personnalisé',
    exchangeDetails: 'Détails de l\'Échange',
    rechargeRules: 'Règles de Recharge',
    sellerLevel: 'Niveau du Vendeur',
    proportion: 'Proportion',
    levelRequirement: 'Exigence de Niveau',
    beginner: 'Débutant',
    singleRecharge: 'Recharge unique',
    standard: 'Standard',
    senior: 'Senior',
    exchangeRules: 'Règles d\'Échange',
    note: 'Note',
    seniorCoin: 'Le vendeur de pièces senior obtient {point} points gratuitement chaque jour. Supplément à ',
    beginnerSeller: 'Vendeur Débutant',
    standardSeller: 'Vendeur Standard',
    seniorSeller: 'Vendeur Senior',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'Veuillez saisir le montant de la recharge, multiples de 100K',
    confirmation: 'Confirmation',
    userName: 'Nom d\'utilisateur',
    theUser: 'L\'utilisateur a été blacklisté',
    enterAmount: 'Entrer le montant',
    pleaseInput3: 'Veuillez saisir le montant',
    theAmount: 'Le montant doit être un multiple de 100000',
    pleaseInput4: 'Veuillez saisir ou sélectionner le montant',
    pleaseSelect: 'Veuillez sélectionner la méthode de vente',
    pleaseInput5: 'Veuillez saisir l\'identifiant utilisateur',
    atLeast: 'Au moins 100K pièces à transférer~',
    pleaseSelect2: 'Veuillez sélectionner le mode de paiement',
    minimum: 'minimum',
    theAmount3: 'Le montant doit être un multiple de 1',
    lessThan: 'inférieur ou égal à 100000',
    orders: 'Commandes',
    applicant: 'Demandeur',
    method: 'Méthode',
    withdrawTime: 'Heure de Retrait',
    viewDetail: 'Voir le Détail',
    toBe: 'À confirmer',
    toBePaid: 'À payer',
    toBeCompleted: 'À compléter',
    completed: 'Terminé',
    abnormal: 'Anormal',
    refused: 'Refused',
    confirmationTimeout: 'Délai de confirmation dépassé',
    paymentTimeout: 'Délai de paiement dépassé',
    binance: 'Binance',
    scanThe: 'Scannez le code QR pour payer',
    quantity: 'Quantité',
    orderAmount: 'Montant de la commande',
    date: 'Date',
    payNow: 'Payer Maintenant',
    payment: 'Paiement',
    pleasePay2: 'Veuillez payer de la manière suivante',
    chainName: 'Nom de la chaîne',
    contractAddress: 'Adresse du contrat',
    theAbove: 'L\'adresse ci-dessus n\'est valable que pour cette recharge',
    copy: 'Copy',
    notice: 'Avis',
    pleaseTransfer: 'Veuillez transférer un supplément de 1 USDT pour couvrir les frais de Binance. Le fait de ne pas le faire peut retarder votre recharge de pièces.',
    paymentsMust: 'Les paiements doivent être effectués dans les 0,5 heure, sinon la plateforme ne sera pas responsable des problèmes.',
    add: 'Ajouter',
    confirmTo: 'Confirmer la suppression de ce mode de paiement',
    countryCurrency: 'Pays et Type de Devise',
    selectPayment: 'Sélectionnez le mode de paiement que vous pouvez envoyer',
    coinsSeller: 'Règles du Vendeur de Pièces',
    standrd: 'Standard',
    salesMethods: 'Méthodes de Vente',
    coinsellerRules: 'Règles du CoinSeller',
    whenApplying: 'Lorsque vous demandez une mise à niveau vers le statut de vendeur de pièces, aucun dépôt n\'est requis, il suffit d\'une seule recharge pour améliorer le niveau du vendeur de pièces. Si vous choisissez de démissionner de votre poste de vendeur de pièces, votre rôle actuel de vendeur de pièces expirera',
    youCanReplenish: 'Vous pouvez recharger votre compte directement avec USDT, Epay ou via un autre vendeur de pièces',
    fraudulentActivities: 'Les activités frauduleuses sont strictement interdites dans la plateforme Hala.',
    anyViolations: 'Toute violation entraînera la résiliation du compte du vendeur de pièces',
    allRights: 'Tous droits réservés par Hala.',
    transferDetail: 'Détail du Transfert'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: 'Invitation',
    tasks: 'Tâches',
    other: 'Autre',
    consume: 'Consommer',
    giftIncome: 'Gift Income',
    received: 'Reçu',
    from: 'de',
    luckyGift: 'Cadeau chanceux',
    hostCenter: 'Centre d\'Hôte',
    noAgent: 'Aucun agent',
    last7: '7 derniers jours',
    hourlyIncome: 'Revenu horaire',
    toReach: 'to reach',
    rules: 'Règles',
    pointsOverview: 'Aperçu des Points',
    totalIncome: 'Total Income',
    gifts: 'cadeaux',
    workDetail: 'Détail du Travail',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: 'Record en direct d\'aujourd\'hui',
    dailyStatistics: 'Statistiques Quotidiennes',
    startTime: 'Heure de début',
    endTime: 'Heure de fin',
    duration: 'Durée',
    points: 'Points',
    date: 'Date',
    giftPoints: 'Points cadeaux',
    removeBinding: 'Supprimer la Liaison',
    thisAction2: 'Cette action vous détachera de {agentName}. Veuillez confirmer si vous souhaitez procéder à la dissociation'
  },
  bombRule: {
    afterThe: 'Après que la valeur de détonation dans la pièce atteigne un certain montant, la bombe cadeau apparaîtra dans la pièce',
    oneCoins: '1 pièce reçue dans la pièce = 1 valeur de détonation',
    itWill: 'Il explosera automatiquement après avoir rempli les conditions, et le propriétaire de la pièce recevra des récompenses correspondantes en pièces d\'or'
  },
  descriptionLevel: {
    wealth: 'Richesse',
    charm: 'Charme',
    wealthValue: 'Valeur de Richesse',
    charmValue: 'Valeur de Charme',
    needTo: 'Nécessité',
    send: 'envoyer',
    receive: 'recevoir',
    forThe: 'pour la mise à niveau',
    theRich: 'Le niveau de richesse est compté par les pièces que vous avez rechargées',
    theCharm: 'Le niveau de charme est calculé en fonction du nombre de pièces que vous recevez',
    LevelLabel: 'Étiquette de Niveau',
    level: 'Level',
    levelLogo: 'Logo de Niveau'
  },
  gameRank: {
    gameRank: 'Classement du Jeu',
    rules: 'Rules',
    thisWeek: 'Cette Semaine',
    lastWeek: 'La Semaine Dernière',
    agentGaming: 'Classement des Revenus des Jeux d\'Agent',
    rankingRewards: 'Récompenses de Classement',
    rankingIs: 'Le classement est basé sur le chiffre d\'affaires total des paris des utilisateurs dans la salle de l\'agent et ses sous-salles.',
    hostRoom: 'Classement des Revenus des Salles d\'Hôte',
    rankingIs2: 'Le classement est basé sur le revenu total des jeux généré dans la salle de l\'hôte',
    notes: 'Notes',
    eventDuration: 'Durée de l\'événement : Chaque semaine civile. Les récompenses ne sont distribuées que si',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Hala se réserve le droit d\'interprétation finale de cet événement',
    rewardsDetail: 'Détail des Récompenses',
    decorationsPreview: 'Aperçu des Décorations'
  },
  gameLegacyHall: {
    surpriseLucky: 'Sac Chanceux Surprise',
    dailyPlayers: 'Les joueurs quotidiens peuvent ouvrir un sac chanceux le lendemain pour des pièces aléatoires',
    eventRule: 'Règle de l\'Événement',
    usersSpending: 'Les dépenses des utilisateurs dans les jeux d\'événements compteront pour leur score de classement',
    thePlatform: 'La plateforme fera tourner les jeux d\'événements toutes les 4 heures, avec 4 jeux différents présentés à chaque rotation',
    theTop: 'Les 3 meilleurs joueurs quotidiens recevront des cadres et des récompenses en pièces',
    theTop2: 'Les 10 meilleurs joueurs hebdomadaires recevront des cadres et des récompenses en pièces',
    usersWho: 'Les utilisateurs qui participent aux jeux d\'événements chaque jour peuvent ouvrir un sac chanceux le lendemain pour recevoir un montant aléatoire de pièces. Plus vous dépensez dans les jeux d\'événements, plus vous pouvez obtenir de pièces',
    behindPrevious: 'Derrière le précédent',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'Compte à rebours:',
    days: 'jours',
    winOver: 'Gagner plus de',
    coinsfrom: 'pièces provenant de jeux en une seule journée',
    earnOver: 'Gagner plus de',
    coinsWitdh: 'avec un taux de retour allant jusqu\'à',
    fromOneDay: 'd\'un jour dans',
    game: 'Jeu',
    fromA: 'd\'un seul pari dans',
    inthisWeek: 'Cette Semaine',
    earnUp: 'Gagner jusqu\'à',
    inAsingle: 'en une seule journée',
    eventRules: 'Règles de l\'événement',
    participateIn: 'Participez au jeu pour réclamer un plus grand sac chanceux demain',
    youDid: 'Vous n\'avez pas reçu la récompense en pièces. Participez au jeu et vous pourrez continuer à réclamer le sac chanceux demain',
    participateIn2: 'Participez au jeu et vous pourrez continuer à réclamer le sac chanceux demain',
    topDaily: 'Meilleur Gagnant Quotidien de Pièces',
    topPayout: 'Meilleur Gagnant du Taux de Paiement',
    topCoins: 'Meilleur Gagnant de Pièces en Un Tour Hebdomadaire',
    topPayout2: 'Meilleur Gagnant du Taux de Paiement en Un Tour Hebdomadaire',
    topWeekly: 'Meilleur Gagnant Hebdomadaire de Pièces',
    historicalTop: 'Meilleur Gagnant Historique de Pièces en Un Jour',
    historicalTop2: 'Meilleur Gagnant Historique du Taux de Paiement en Un Jour',
    historicalTop3: 'Meilleur Gagnant Historique de Pièces en Un Tour',
    historicalTop4: 'Meilleur Gagnant Historique du Taux de Paiement en Un Tour',
    historicalTop5: 'Meilleur Gagnant Historique de Pièces en Une Semaine',
    gameReward: 'Récompense de jeu',
    usersSpending2: 'Les dépenses des utilisateurs dans les jeux d\'événements compteront pour leur score de classement',
    theTop3: 'Les 3 meilleurs joueurs quotidiens recevront des cadres et des récompenses en pièces',
    theTop4: 'Les 10 meilleurs joueurs hebdomadaires recevront des cadres et des récompenses en pièces',
    usersWho2: 'Les utilisateurs qui participent aux jeux d\'événements chaque jour peuvent ouvrir un sac chanceux le lendemain pour recevoir un montant aléatoire de pièces. Plus vous dépensez dans les jeux d\'événements, plus vous pouvez obtenir de pièces',
    coins: 'Pièces',
    flameRider: 'Cavalier de Flamme',
    sportCar: 'Voiture de Sport',
    captainMeow: 'Capitaine Miaou',
    profileFrame: 'Cadre de Profil'
  },
  gold: {
    coinsDetail: 'Détail des Pièces',
    coinBalance: 'Solde de Pièces',
    all: 'ALL',
    sendGifts: 'Envoyer des Cadeaux',
    purchaseItems: 'Acheter des Articles',
    games: 'Jeux',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'Récompenses d’Activité',
  },
  integral: {
    all: 'All',
    cashOut: 'Retirer',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: 'Heure de Retrait',
    pointsAmount: 'Montant des Points',
    depositAmount: 'Montant du Dépôt',
    coinsAmount: 'Montant de Pièces',
    transferTo: 'Transférer à',
    normal: 'Normal',
    pending: 'En Attente',
    success: 'Success',
    failed: 'Échec',
    points: 'Points',
    pointsBalance: 'Solde de Points',
    frozenPoints: 'Points Gelés',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: 'Type de Devise',
    paymentMethod: 'Payment method',
    pointsAmount2: 'Montant des points pour le retrait',
    enterA: 'Entrez un multiple de 100 000 (minimum 200 000)',
    enterA2: 'Entrez un multiple de 100000',
    accountInformation: 'Informations sur le compte',
    withdraw: 'Retirer',
    amount: 'Amount',
    exchangeRate: 'Taux de change',
    exchangePoints: 'Points d\'échange',
    enterUserId: 'Entrez l\'ID utilisateur',
    check: 'Check',
    fee: 'Frais',
    theAgency: 'L\'agence recevra',
    transferFee: 'Frais de transfert : 2 %. Transfert minimum ≥ 100 000 points.',
    clickTransfer: 'Cliquez sur le bouton de transfert pour transférer les points correspondants à vos agents',
    afterThe2: 'Une fois le transfert terminé, il ne peut pas être annulé ou retiré',
    transferPoints: 'Points de transfert',
    recommendedMethod: 'Méthode recommandée',
    lowerFees: 'Frais réduits et examinés dans les 24 heures',
    paymentPassword: 'Mot de passe de paiement non défini',
    cashOut2: 'Les retraits et les échanges nécessitent une vérification du mot de passe de paiement. Veuillez d\'abord configurer votre mot de passe de paiement.',
    cancel: 'Cancel',
    goTo: 'Aller aux paramètres',
    youHave: 'Vous avez atteint 5 tentatives infructueuses. Une tentative infructueuse supplémentaire entraînera le gel de votre compte. Si vous avez oublié votre mot de passe, veuillez le réinitialiser.',
    inputIncorrect: 'Saisie incorrecte du mot de passe plusieurs fois. Votre compte a été gelé, veuillez réessayer après',
    verify: 'vérifier',
    gotIt: 'Got it',
    pointsInfo: 'Informations sur les points',
    whenA: 'Lorsqu\'un utilisateur vous envoie des cadeaux en utilisant des pièces rechargées via Google, les points que vous recevez seront gelés pendant 7 jours avant de devenir disponibles. Si l\'utilisateur demande un remboursement, ces points seront déduits. Veuillez suivre les règles de la plateforme et éviter toute violation.',
    frozenPointsAre: 'Les points gelés sont inclus dans le solde total des points',
    theUser2: 'L\'utilisateur a été blacklisté',
    successfulWithdrawal: 'Retrait réussi',
    withdrawalAmount: 'Montant du retrait',
    theFunds: 'Les fonds arriveront dans les 24 heures',
    pleaseEnter2: 'Veuillez saisir le mot de passe',
    passwordIncorrect: 'Mot de passe incorrect',
    theAmount4: 'Le montant doit être un multiple de 100000',
    pleaseEnter3: 'Veuillez saisir l\'ID utilisateur',
    pleaseEnter4: 'Veuillez saisir l\'ID utilisateur correct',
    pleaseEnter5: 'Veuillez saisir le montant',
    minimumTransfer: 'Transfert minimum ≥ 100 000 points',
    pleaseSelect3: 'Veuillez sélectionner la méthode',
    minimum: 'minimum',
    theAmount5: 'Le montant doit être inférieur à',
    illegalInput: 'Saisie illégale',
    pleaseEnter6: 'Veuillez saisir les informations du compte'
  },
  invite: {
    inviteGame: 'Inviter un utilisateur de jeu',
    currentRebate: 'Rabais actuel',
    need: 'besoin',
    toProgress: 'pour progresser au niveau suivant',
    gameReward: 'Game Reward',
    referralData: 'Données de parrainage',
    referralList: 'Liste de parrainage',
    date: 'Date',
    gameBets: 'Paris de jeu',
    inviteRewards: 'Récompenses d\'invitation',
    viewMore: 'Voir plus',
    inviteFriends: 'Inviter des amis',
    myReward: 'Ma récompense',
    totalRewards: 'Total des récompenses',
    dailyReward: 'Récompense quotidienne',
    inviteRules: 'Règles d\'invitation',
    yourRebate: 'Votre taux de rabais dépend de vos paris valides totaux des 30 derniers jours',
    totalValid2: 'Paris valides totaux = Vos propres paris + Les propres paris de chaque niveau de vos utilisateurs invités',
    rebateFrom: 'Rabais des utilisateurs invités de niveau 1 = Leurs propres paris × Votre taux de rabais',
    rebateFrom2: 'Rabais des utilisateurs invités de niveau 2 = Leurs propres paris × (Votre taux de rabais - Taux de rabais de niveau 1)',
    ifThe: 'Si l\'utilisateur invité de niveau 2 invite un utilisateur de niveau 3, cela peut augmenter ses paris valides totaux, mais il ne peut pas obtenir de rabais du niveau 3.',
    example: 'Exemple',
    tier1: 'Niveau 1 invité - Comment calculer le rabais de ceux qui sont directement invités par vous ?',
    asRebate: 'Rabais de A de B, C et D = (Paris propres de B + Paris propres de C + Paris propres de D) × Taux de rabais de A =',
    bsRebate: 'Rabais de B de E et F = (Paris propres de E + Paris propres de F) × Taux de rabais de B =',
    csRebate: 'Rabais de C de G = Paris propres de G × Taux de rabais de C =',
    tier2: 'Niveau 2 invité - Comment calculer le rabais de ceux qui sont indirectement invités par vous ?',
    asRebate2: 'Rabais de A de E et F = (Taux de rabais de A - Taux de rabais de B) × (Paris propres de E + Paris propres de F) =',
    asRebate3: 'Rabais de A de G = (Taux de rabais de A - Taux de rabais de C) × Paris propres de G =',
    myInvitation: 'Mon Invitation',
    search: 'Search',
    invitationTime: 'Heure d\'invitation',
    inviteHost: 'Invite Host',
    inviteA: 'Inviter un hôte, chacun jusqu\'à',
    todayRewards: 'Récompenses d\'aujourd\'hui',
    rewardDetail: 'Détail de la récompense',
    creatorRewards: 'Portefeuille de récompenses du créateur',
    collect: 'Collecter',
    invitationDate: 'Date d\'invitation',
    hostPolicy: 'Politique d\'hôte',
    halaReserves2: 'Hala se réserve le droit d\'interprétation finale des politiques ci-dessus.'
  },
  listContribution: {
    contributiont: 'Contribution',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: 'Hier',
    game: 'Game',
    gift: 'Cadeau',
    hostEarnings: 'Gains de l\'hôte'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Hala se réserve le droit d\'interprétation finale des politiques ci-dessus'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'Changer de compte',
    countryRegion: 'Pays/Région',
    officialAgency: 'Recharge d\'agence officielle',
    ttOff: '20% de réduction',
    totalAmount: 'Montant total',
    purchase: 'Acheter',
    pleaseComfirm: 'veuillez confirmer l\'ID utilisateur',
    pleaseInput8: 'Veuillez saisir l\'ID utilisateur',
    onlineService: 'Service en ligne',
    dealOf: 'Transaction des 30 derniers jours',
    recent30Day2: 'Ventes de pièces des 30 derniers jours',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'Votre pays n\'a actuellement aucun vendeur de pièces disponible',
    pleaseContact2: 'Veuillez contacter le service client.',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'La progression du coffre au trésor est augmentée en offrant des cadeaux dans la pièce',
    whenThe: 'Lorsque la barre de progression de la clé du coffre est remplie, le coffre au trésor s\'ouvrira',
    afterThe3: '.Après que les coffres au trésor de niveau 3 et 4 répondent aux exigences, ils seront verrouillés pendant 1 minute puis ouverts automatiquement',
    everyoneIn: 'Chaque personne présente dans la pièce a une chance de remporter les récompenses du coffre au trésor.',
    onceThe: 'Une fois le coffre au trésor ouvert, le système peut mettre quelques minutes à créditer votre compte. Les pièces d\'or seront ajoutées à votre solde et le costume à votre inventaire.',
    theHigher: 'Plus le niveau du coffre au trésor est élevé, plus les récompenses qu\'il contient sont importantes.',
    ifYou2: 'Si vous êtes sélectionné comme VIP avec un niveau VIP inférieur à votre niveau actuel, ce niveau VIP ne sera pas pris en compte.',
    theProgress: 'La barre de progression de la clé du coffre sera réinitialisée chaque jour à 00h00 (UTC+5:30).'
  },
  share: {
    joinHala: 'Rejoignez Hala pour débloquer de multiples opportunités de revenus et bénéficier d\'avantages et de récompenses personnalisés pour les agences.',
    downloadTo: 'Téléchargez pour devenir partenaire',
    joinHala2: 'Rejoignez Hala pour des jeux amusants et une chance de gagner des prix exceptionnels.',
    downloadAnd: 'Téléchargez et commencez à gagner',
    joinHala3: 'Rejoignez Hala et lancez-vous dans l\'aventure de l\'hébergement. Gagnez jusqu\'à 36 $ de bonus quotidiens !',
    inviteYou: 'Nous vous invitons à rejoindre l\'agence',
    downloadNow: 'Téléchargez maintenant pour commencer l\'hébergement',
    comeWith: 'Rejoignez-moi pour discuter dans le salon de discussion de Hala.',
    enthusiastsFrom: 'Des passionnés du monde entier se réunissent pour partager...',
    igniteEndless: 'Suscitez un divertissement sans fin',
    download: 'Télécharger',
    halaLive: 'Hala Live',
    showMe: 'Montre-moi le monde heureux',
    saySomething: 'Dire quelque chose...',
    downloadHala: 'Téléchargez l\'application Hala'
  },
  starHost: {
    starHost: 'Animateur vedette',
    level2: 'Niveau {level} maintenu pendant {days} jours',
    currentSalary: 'Salaire actuel',
    points: 'Points',
    likes: 'Goûts',
    stillNeed: 'Still need',
    done: 'Fait',
    numberOf2: 'Nombre de donateurs',
    gifters: 'donateurs',
    gcoinGifts: 'Cadeaux Gcoin',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: 'min',
    completeAll: 'Effectuez toutes les tâches suivantes pour effectuer la mise à niveau.',
    follower: 'Disciple',
    numberOf3: 'Nombre de donateurs',
    daysAt: 'Jours au niveau {level}',
    giftCollection: 'Collection de cadeaux',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: 'prétentions',
    gcoin: 'Gcoin',
    status: 'Statut',
    levelReached: ' Niveau atteint',
    notAchieved: 'Non atteint',
    starHost2: 'Règles de l\'hôte vedette',
    eachStar: 'Chaque Star Host bénéficie d\'une période d\'essai de 3 jours.',
    theyWill: 'Ils ne deviendront animateurs vedettes officiels que s\'ils atteignent le niveau A pendant les 3 jours.',
    thoseWho: 'Ceux qui ne parviennent pas à atteindre les objectifs quotidiens en matière de résultats au baccalauréat seront licenciés.',
    firedHosts: 'Les animateurs licenciés ne peuvent pas percevoir le salaire de base d\'animateur vedette.',
    starHost3: 'Le salaire de base de Star Host est versé chaque semaine, tous les lundis.',
    ifA: 'Si un animateur vedette ne parvient pas à accomplir ses tâches quotidiennes, il ne recevra que 50 % de son salaire horaire.',
    selfGifting: 'S\'offrir des cadeaux à soi-même est strictement interdit pour tous les destinataires de cadeaux.',
    starHost4: 'Récompenses d\'hôte vedette de différents niveaux',
    level: 'Level',
    dailyExtra: 'Récompenses quotidiennes en points supplémentaires',
    liveBroadcast: 'Temps de diffusion en direct requis',
    starHost5: 'Exigences relatives à l\'hôte vedette pour différents niveaux',
    requirements: 'Exigences)',
    yourApplication: 'Votre demande a été approuvée par les autorités compétentes.',
    stayOn: 'Restez au niveau A pendant 7 jours',
    over1k: 'Plus de 1 000 fans',
    totalGifter: 'Nombre total de donateurs > 300',
    receiveAll: 'Recevez tous les cadeaux « chanceux »',
    everyLucky: 'Chaque numéro porte-bonheur doit être supérieur à 100.',
    stayOn2: 'Séjournez au niveau S pendant 10 jours',
    over2k: 'Plus de 2 000 fans',
    totalGifter2: 'Nombre total de donateurs > 300',
    receiveAll2: 'Recevez tous les cadeaux « chauds »',
    stayOn3: 'Restez au niveau SS pendant 10 jours',
    over5k: 'Plus de 5 000 fans',
    totalGifter3: 'Nombre total de donateurs > 1000',
    receiveAll3: 'Recevez tous les cadeaux « de luxe »',
    starHost6: 'Tâches quotidiennes de l\'hôte vedette',
    dailyAssessment: '(Système d\'évaluation quotidienne) : Interaction / Cadeaux',
    gcionGifts: 'Cadeaux Gcion',
    rulesTo: 'Règles pour dégrader le niveau d\'hôte étoile',
    failTo: 'Ne pas atteindre les normes du niveau actuel pendant 3 jours consécutifs.',
    failingTo: 'Ne pas avoir respecté les normes <span>3 fois en une semaine',
    ifThe2: 'Si l\'hôte de niveau A ne remplit pas les exigences quotidiennes, il sera licencié sans autre forme de procès. Après une rétrogradation, il devra satisfaire aux exigences de son niveau initial pendant trois jours consécutifs pour le retrouver.',
    involvementIn: 'Implication dans des violations majeures ou des incidents négatifs.',
    causingDamage: 'Porter atteinte aux intérêts ou à l\'image de marque de la plateforme',
    applyFor: 'Demande de démission par vous-même',
    liveStreaming: 'Exigences de diffusion en direct',
    liveStream: 'Le contenu diffusé en direct doit correspondre au type désigné par l\'hôte.',
    roomHosts: 'Il est interdit aux animateurs de salle de couper leur micro pendant des périodes prolongées lors des diffusions.',
    liveStreams: 'Les diffusions en direct doivent être réalisées dans une salle équipée de 9 microphones.',
    otherSeats: 'Les autres sièges de la salle ne peuvent être occupés par des utilisateurs ou des membres du public qui coupent leur micro à des fins de farming de tâches.',
    discriminatoryInsulting: 'Les propos discriminatoires, insultants ou offensants sont strictement interdits dans la salle.'
  },
  starRoom: {
    afterCountdown: 'Après un décompte quotidien, les 3 meilleures chambres seront affichées dans le classement des chambres étoilées.',
    top20Star: 'Les 20 meilleures chambres seront récompensées par un généreux bonus après cette semaine.',
    countdown: 'Countdown：',
    top3Daily: 'Les 3 meilleures chambres du jour seront qualifiées pour participer aux salles étoilées hebdomadaires.',
    starRooms: 'Les salles étoilées seront classées le dernier jour de la semaine. Ce classement sera établi en fonction du flux total de pièces de chaque salle.',
    top20Weekly: 'Les 20 meilleurs propriétaires de chambres étoilées de la semaine recevront les récompenses suivantes',
    qualificationTo: 'Conditions de participation à cet événement : Toute infraction ou tout comportement illégal est interdit dans la salle. En cas d’infraction constatée, la salle sera disqualifiée et retirée du classement.',
    theRewards: 'Les récompenses seront envoyées tous les lundis.',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'Inviter les hôtes',
    pointsMax: '5 000 points maximum par jour',
    firstRecharge: 'Utilisateurs de première recharge',
    get20: 'Obtenez 20 $ gratuitement',
    oneInvite: '1. Invitez les hôtes à démarrer en direct, une fois que les hôtes que vous avez invités ont terminé.',
    aFinish: 'a. Terminez la vérification faciale sur le centre de tâches.',
    bCreate: 'b. Créer sa propre chambre',
    cLive: 'c.En direct au micro pendant 3 heures dans sa chambre',
    dClaim: 'd. Réclamez vos récompenses en direct pour la première fois.',
    youGet: 'Vous recevez des points de récompense chaque jour grâce aux numéros valides de vos hôtes invités. Vous pouvez réclamer vos récompenses le lendemain.',
    validHost: 'Hôte valide',
    pointsReward: 'Points de récompense',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: 'Mes hôtes invités',
    validHosts: 'Hôtes valides aujourd\'hui',
    pointsRewards: 'Récompenses en points',
    validHosts2: 'Hôtes valides hier :',
    claim: 'Réclamer',
    claimed: 'Réclamé',
    completedTime: 'Temps écoulé',
    ifYour: 'Si vos amis effectuent la première recharge, vous recevrez de nombreuses récompenses. (La recharge hors ligne sera également incluse).',
    theMore: 'Plus le montant de la première recharge est élevé, plus vous recevrez de pièces en récompense, jusqu\'à 20 $ par jour.',
    inviteesRecharge: 'Pièces de recharge pour invités',
    yourReward: 'Vos pièces de récompense',
    threeOnly: '3. Seuls les utilisateurs invités à recharger dans les 30 jours seront comptabilisés comme utilisateurs de première recharge valides.',
    seniorAnd: 'Les vendeurs seniors et standard ne seront comptabilisés que lorsqu\'ils effectueront leur premier rechargement depuis l\'application ou directement depuis le site officiel (consultez votre administrateur pour connaître les modes de paiement).',
    myInvited2: 'Mes utilisateurs invités',
    rechargeCoins: 'Pièces de recharge',
    coinsRewards: 'Récompenses en pièces',
    firstRecharge2: 'Pièces de première recharge hier :',
    firstRecharge3: 'Pièces de première recharge',
    firstRecharge4: 'Temps de première recharge'
  },
  hostPolicy: {
    title: 'Politique de l\'Hôte',
    section1Title: 'Salaire de Base de la Première Semaine pour les Nouveaux Hôtes',
    requirement: 'Exigence',
    newHostsDesc: 'Nouveaux hôtes qui ont rejoint Hala au cours de la première semaine',
    activeTime: 'Temps Actif sur le Micro',
    oneHour: '1 Heure',
    twoHour: '2 Heures',
    threeHour: '3 Heures',
    baseSalary: 'Salaire de Base (Points)',
    incomeRequirement: 'Exigence de Revenu',
    none: 'Aucun',
    remarks: 'Remarques',
    remarksDesc: 'Maximum 3 heures/jour. Maximum 7 jours. Récompense maximale totale de 35 000 points',
    note1: 'À partir de la date d\'enregistrement de l\'hôte, la période de validité du salaire de base de 7 jours commence le compte à rebours.',
    note2: 'Les hôtes utilisant plusieurs comptes ou se connectant avec plusieurs IP ou appareils seront disqualifiés de la récompense de salaire de base.',
    note3: 'Si les revenus des 7 derniers jours de l\'hôte dépassent 150 000 points, elle obtiendra la Récompense Horaire d\'Hôte Ordinaire au lieu de la Récompense de Salaire de Base du Nouvel Hôte.',
    section2Title: 'Récompense Équitable pour l\'Hôte Ordinaire',
    level: 'Niveau',
    incomeRequirementShort: 'Exigence de Revenu',
    hourlyReward: 'Récompense Horaire',
    maximumDailyHours: 'Heures Quotidiennes Maximales',
    section2Note1: '15 minutes consécutives sur le micro seront comptées comme temps effectif.',
    section2Note2: 'Toutes les récompenses sont réglées en points et doivent être réclamées sur le système de tâches.',
    section2Note3: 'Les récompenses de la plateforme ne seront pas comptées dans les exigences de points.',
    section2Note4: 'Les points seront déduits dès que plusieurs IP ou appareils seront détectés.',
    section2Note5: 'Les 7 derniers jours signifient les 6 derniers jours+aujourd\'hui, donc vos récompenses horaires peuvent augmenter à mesure que vous atteignez rapidement des niveaux de points plus élevés.',
    section2Note6: 'Les récompenses hors objectif de niveau L ne seront valides que pendant les 7 premiers jours après l\'enregistrement. Après 7 jours, les hôtes peuvent obtenir 500 points gratuits chaque jour de manière permanente.',
    section3Title: 'Réglementations de l\'Hôte',
    regulation1: 'Il est interdit aux hôtes d\'enregistrer plusieurs comptes.',
    regulation2: 'Il est interdit de promouvoir des plateformes tierces.',
    regulation3: 'Les mineurs sont strictement interdits.',
    regulation4: 'Un hôte ne peut avoir qu\'une seule ID vérifiée. Seules les ID vérifiées peuvent commencer le streaming en direct et retirer les gains.',
    regulation5: 'Tout acte d\'usurpation d\'authentification faciale pour commencer le streaming en direct ou retirer les gains sera banni définitivement.',
    regulation6: 'Fournir une ID à d\'autres pour le streaming en direct entraînera l\'interdiction permanente de l\'ID par le système.',
    regulation7: 'Dans le salon vocal, les hôtes doivent saluer activement les utilisateurs entrant dans le salon.',
    regulation8: 'La photo de couverture du salon vocal doit utiliser une photo réelle et conforme de l\'hôte.',
    regulation9: 'La plateforme Hala interdit strictement toute activité frauduleuse. Toute violation entraînera la suspension permanente du compte.',
    footer: 'Hala se réserve le droit d\'interprétation finale des politiques ci-dessus.',
  },
  correspondingRevenue: 'les exigences de revenu correspondantes sont respectées. Toutes les récompenses seront émises',
  within12: 'dans les 1-2 jours ouvrables après la fin de l\'événement'
}
